<template>
    <div class="logInComponent">
      <div class="logInContainer">
        <div class="logInCard">
            <div class="logoContainer">
                <img alt="ACG logo" class="logo" src="@/assets/img/logoblack.svg" />
            </div>
         
            <div  style="padding : 20px;">
              <div class="inputContainer" style="padding : 20px;">
                  <h3>E-mail validation!</h3>
                  
                  <p v-if="user == true">You have successfully validated your email account, log in using the link below:</p>
                  <p  v-if="user == false">This email address has already been validated or uses a code that does not exist!</p>
              </div>
                
                  
                  
                
                <div class="error--s form__error" v-if="error.length > 0">{{error}}</div>
                <a href="/"><button  class="btn btn-green logInButton">Go to Login Page</button></a>
              </div>
            </div>
            
         
        </div>
      </div>
   
  </template>
  
  <script>
 
 
  
  export default {  
    data(){
      return{
        
        user: undefined,
        error: []
      }
    },
    
    created(){
        var _this = this;
      
          _this.post('emailverification',{email_token : this.$route.params.token},{},function(){
            console.log('oksa')
           _this.user = true;
            _this.$forceUpdate();
          },function(){
            _this.user = false;
            console.log('nem oksa')
          })
    },
    methods:{
      
    }
  }
  </script>